export default __webpack_public_path__ + "static/media/staking-snowflake.27a0bf64.svg";